import React, {useState} from "react";
import auth from "../../../utils/authentication";
import {Link, useNavigate} from "react-router-dom";
import {FormattedMessage, useIntl} from "react-intl";
import GoogleLogin from "../googleLogin/googleLogin";
import {isMobileDevice, validateEmail} from "../../../utils/utils";
import {toast} from "react-toastify";

function ForgotPassword({setCurrentPage}) {

    const intl = useIntl();

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [showDisableButton, setShowDisableButton] = useState(false);

    const enableUser = (e) => {
        e.preventDefault();
        dismissError();
    }

    const loginUser = async (e) => {
        e.preventDefault();
        dismissError();
        if(validateEmail(email)){
            await auth.sendPasswordResetEmail(email).then(() => {
                toast.info(
                    <div>
                        <FormattedMessage id="users.recover-password.sent-toast" values={{email}}/>
                    </div>
                )
                setCurrentPage("login");
            }).catch(error => {
                if(error.message.includes('(auth/user-not-found)')){
                    toast.error(
                        <div>
                            <FormattedMessage id="users.recover-password.error.no-account"/>
                        </div>
                    )
                }
            })

        } else{
            toast.error(
                <div>
                    <FormattedMessage id="users.recover-password.error.email"/>
                </div>
            )
        }
    }

    function dismissError(){
        setError("");
        document.querySelectorAll('input').forEach(x => x.classList.remove('is-invalid'))
    }

    const colSize = isMobileDevice() ? "col-10" : "col-7";

    return (
        <div className="col-12">
            <h2 className="text-center"><FormattedMessage id="users.recover-password.title"/></h2>
            <div className="d-flex flex-row align-items-center col-12 justify-content-center">
                <hr className="col-10"/>
            </div>
            <form className="d-flex flex-row flex-wrap col-12 justify-content-center">
                <div className={colSize}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                {error && <div className="alert alert-danger alert-dismissible fade show col-7" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => dismissError()}/>
                </div>}

                <div className={"form-floating mb-3 " + colSize}>
                    <input value={email} onChange={e => {
                        setEmail(e.target.value);
                        setShowDisableButton(false);
                    }}
                           type="email" className="form-control" id="floatingInput" placeholder="Correo electrónico"/>
                    <label htmlFor="floatingInput"><FormattedMessage id="users.input.email"/></label>
                </div>
                <div className={colSize + " mb-3 d-flex flex-row justify-content-between"}>
                    {!showDisableButton && <button className="btn btn-primary" type="submit" onClick={e => {
                        loginUser(e);
                    }}><FormattedMessage id="users.recover-password.send"/></button>}
                </div>
                <div className={colSize + " mb-3"}>
                    <b><FormattedMessage id="users.login.dont-have-account"/></b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}}  onClick={() => setCurrentPage("signUp")}><FormattedMessage id="users.login.sign-up"/></a>
                </div>
                <div className={"mb-3 " + colSize}>
                    <b><FormattedMessage id="users.login.already-have-account"/></b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}} onClick={() => setCurrentPage("login")}><FormattedMessage id="users.login.log-in"/></a>
                </div>
            </form>
        </div>
    )
}

export default ForgotPassword;
